export default "__VITE_ASSET__66tapiFq__"